import { useToast } from '../toast'

export const useCopyToClipboard = (copyText: string, { showToast }: { showToast?: boolean } = { showToast: true }) => {
  const { showSuccess, showError } = useToast()
  const isCopyDisabled = !window?.navigator?.clipboard?.writeText
  const copy = () => {
    if (!isCopyDisabled) {
      window?.navigator?.clipboard
        .writeText?.(copyText)
        .then(() => showToast && showSuccess(`Copied to clipboard: ${copyText}`))
        .catch(() => showToast && showError('Copy failed'))
    }
  }
  return { copy, isCopyDisabled }
}
